"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OrderedList = exports.ListItem = exports.List = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var List = _styledComponents.default.ul.withConfig({
  displayName: "List",
  componentId: "sc-4j87st-0"
})(["padding-left:20px;list-style-type:disc;margin-bottom:1em;"]);

exports.List = List;

var ListItem = _styledComponents.default.li.withConfig({
  displayName: "List__ListItem",
  componentId: "sc-4j87st-1"
})(["margin-bottom:0.5em;"]);

exports.ListItem = ListItem;

var OrderedList = _styledComponents.default.ol.withConfig({
  displayName: "List__OrderedList",
  componentId: "sc-4j87st-2"
})(["padding-left:20px;list-style-type:decimal;margin-bottom:1em;"]);

exports.OrderedList = OrderedList;